import portfolioImg01 from "../images/portfolio-01.png";
import portfolioImg02 from "../images/portfolio-02.png";
import portfolioImg03 from "../images/portfolio-03.png";
import portfolioImg04 from "../images/portfolio-04.png";
import portfolioImg05 from "../images/portfolio-05.png";
import portfolioImg06 from "../images/portfolio-06.png";
import portfolioImg07 from "../images/portfolio-07.png";
import portfolioImg08 from "../images/portfolio-08.png";
import portfolioImg09 from "../images/portfolio-09.png";
import portfolioImg10 from "../images/portfolio-10.png";
import portfolioImg11 from "../images/portfolio-11.png";
import portfolioImg12 from "../images/portfolio-12.png";
import portfolioImg13 from "../images/portfolio-13.png";

const portfolios = [
    {
        id: "01",
        imgUrl: portfolioImg01,
        category: "Web Design",
        title: "Notes Making App",
        description:
            "The ReactJS notes-making app is a user-friendly and efficient application that allows users to create, manage, and organize their notes. Users can effortlessly create new notes by typing their content into the input area and easily add them to the list with the 'Add Note' button. The app offers a convenient 'Delete' button next to each note.",
        technologies: ["ReactJs", "Cascading Style Sheets (CSS)", "JavaScript", " JavaScript Libraries"],
        siteUrl: "https://mukeshreactnotes.netlify.app/",
    },
    {
        id: "02",
        imgUrl: portfolioImg02,
        category: "Coding Profile",
        title: "Geeks-For-Geeks",
        description:
            "Passionate coder with expertise in C++, data structures, and algorithms. Future Goals: Landing a role in a tech company that values algorithmic problem-solving skills.",
        technologies: ["C++", "Data Structure and Algorithms"],
        siteUrl: "https://auth.geeksforgeeks.org/user/mukeshkir/?utm_source=geeksforgeeks&utm_medium=my_profile&utm_campaign=auth_user",
    },
    {
        id: "03",
        imgUrl: portfolioImg03,
        category: "Coding Profile",
        title: "LeetCode",
        description:
            "Passionate coder with expertise in C++, data structures, and algorithms. Future Goals: Landing a role in a tech company that values algorithmic problem-solving skills.",
        technologies: ["C++", "Data Structure and Algorithms"],
        siteUrl: "https://leetcode.com/Mukeshkir/",
    },
    {
        id: "04",
        imgUrl: portfolioImg04,
        category: "Coding Profile",
        title: "Coding Ninjas",
        description:
            "Passionate coder with expertise in C++, data structures, and algorithms. Future Goals: Landing a role in a tech company that values algorithmic problem-solving skills.",
        technologies: ["C++", "Data Structure and Algorithms"],
        siteUrl: "https://www.codingninjas.com/studio/profile/f6fb5472-a46f-44aa-bc88-cadf70364383",
    },
    {
        id: "05",
        imgUrl: portfolioImg05,
        category: "Web Design",
        title: "Hotel Booking App",
        description:
            "A React application that manages the process of booking a hotel room. Hotel Booking System is online reservation system that processes all hotel reservations made through hotel website and manage hotel room availability and bookings online. It also provides instant confirmation for hotel bookings and increase customer experience",
        technologies: ["ReactJs", "Cascading Style Sheets (CSS)", "JavaScript", " JavaScript Libraries"],
        siteUrl: "https://hotelbookingmukesh.netlify.app/",
    },

    {
        id: "06",
        imgUrl: portfolioImg06,
        category: "Web Design",
        title: "Fiverr Clone App",
        description:
            "A React application that manages the process of Fiverr app. Fiverr is one of the best freelance marketplaces, where employers can hire non-staff service providers for short-term projects such as copywriting, editing, graphic design, marketing, logo creation, etc",
        technologies: ["ReactJs", "Cascading Style Sheets (CSS)", "SAAS", "JavaScript", " JavaScript Libraries"],
        siteUrl: "https://fiverrclone1.netlify.app/",
    },
    {
        id: "07",
        imgUrl: portfolioImg07,
        category: "Web Design",
        title: "NewsAPI App",
        description:
            "NewsAPI is the go-to destination for individuals seeking reliable, diverse, and real-time news updates. With its user-friendly interface, customizable features, and commitment to providing accurate information, NewsAPI ensures users stay informed and engaged with the world's latest events.",
        technologies: ["ReactJs", "Cascading Style Sheets (CSS)", "RESTAPI", "API"],
        siteUrl: "https://github.com/mukesh567/NewsAPI",
    },
    {
        id: "08",
        imgUrl: portfolioImg08,
        category: "Web Design",
        title: "E-commerce Website",
        description:
            "Innovative e-commerce enthusiast who meticulously crafted and launched a dynamic online marketplace, seamlessly integrating a secure and user-friendly payment functionality. Leveraging a robust e-commerce platform, I ensured a seamless shopping experience for customers while maintaining their data privacy",
        technologies: ["NodeJS", "MySQL", "JavaScript", "HTML/CSS"],
        siteUrl: "https://github.com/mukesh567/E-comm",
    },
    {
        id: "09",
        imgUrl: portfolioImg09,
        category: "Web Design",
        title: "Weather App",
        description:
            "Comprehensive weather website enriched with real-time data through API integration. Through thoughtful design and intuitive user interface, I've harnessed the power of weather APIs to provide users with accurate forecasts and current conditions",
        technologies: ["HTML5", "Cascading Style Sheets (CSS)", "JavaScript", "API"],
        siteUrl: " https://mukesh567.github.io/Weather-App/",
    },
    {
        id: "10",
        imgUrl: portfolioImg10,
        category: "Web Design",
        title: "Tin-Dog Website",
        description:
            "web developer behind the innovative Tindog platform, where the love for dogs meets modern technology. Through this dynamic website, I've created a captivating space for dog enthusiasts, offering a seamless blend of social interaction and dog adoption",
        technologies: ["HTML5", "Cascading Style Sheets (CSS)", "JavaScript"],
        siteUrl: "https://mukesh567.github.io/TinDog-Completed-Website/",
    },
    {
        id: "11",
        imgUrl: portfolioImg11,
        category: "Coding Profile",
        title: "Sudoku Solver",
        description:
            "Passionate puzzle solver and developer behind a captivating Sudoku Solver website, ingeniously crafted with the prowess of Data Structures and Algorithms (DSA), specifically employing the powerful technique of backtracking. ",
        technologies: ["Data Structure and Algorithms", "JavaScript", "BackTracking"],
        siteUrl: "https://mukesh567.github.io/SudokuProject/",
    },
    {
        id: "12",
        imgUrl: portfolioImg12,
        category: "Coding Profile",
        title: "Sorting Visualizer",
        description:
            "Through this immersive platform, users are invited to witness the mesmerizing dance of algorithms as they effortlessly arrange arrays into orderly sequences. By seamlessly integrating sorting algorithms like Bubble Sort, Quick Sort, and Merge Sort, the website provides a hands-on learning experience that highlights the efficiency and intricacies of each method",
        technologies: ["Data Structure and Algorithms", "JavaScript", "Sorting Algorithms", "CSS", "SCSS"],
        siteUrl: "https://mukesh567.github.io/sortingVisualizer/",
    },
    {
        id: "13",
        imgUrl: portfolioImg13,
        category: "Coding Profile",
        title: "Interview DSA Problems",
        description:
            "I solved more then 300 problems and all topics are covers! Topics like: Dynamic programming,Graph,Tree etc.",
        technologies: ["Data Structure and Algorithms", "C++"],
        siteUrl: "https://github.com/mukesh567/ALL-DSA-PROBLEMS",
    },

];

export default portfolios;